// extracted by mini-css-extract-plugin
export default {"card":"y4-z"};